/*	==================================================================================================================================
	==================================================================================================================================
	===================================== Copyright: Nasriya Software, LLC. (www.nasriya.net) ========================================
	==================================================================================================================================
	==================================================================================================================================
*/
import { checkRequest } from 'backend/requests.jsw';

$w.onReady(function () {
    initializePage();
});

function initializePage() {
    step1();

    function step1() {
        $w('#submittingLoading').scrolling = 'no';

        $w('#fullName, #warrantyReference').onInput(() => {
            let name = $w('#fullName').value;
            let reference = $w('#warrantyReference').value;

            if (reference.length > 0 && name.length > 0) {
                $w('#checkRequest').enable();
            } else {
                $w('#checkRequest').disable();
            }
        })

        $w('#checkRequest').onClick(() => {
            $w('#requestStages').changeState('checkingRequest').then(async () => {
                $w('#checkRequest').enable();

                await checkRequest($w('#fullName').value, $w('#warrantyReference').value).then((result) => {
                    console.info(result)
                    if (result.ok) {
                        const json = result.json;                  
                        console.log(result.json)
                        if (json.callstatus === 'בתהליך') {
                            $w('#status').text = "בקשתך עדיין ממתינה לבדיקה, אנא המתן!";
                        } else {
                            $w('#status').text = String(json.callstatus);
                        }

                        if (json.csoid) {
                            $w('#referenceId').text = String(json.csoid);
                        } else {
                            $w('#referenceId').text = 'Error';
                        }

                        if (json.opendate) {
                            $w('#requestedOn').text = String(json.opendate);
                        } else {
                            $w('#requestedOn').text = 'Error';
                        }

                        if (json.Referencedescription) {
                            $w('#description').text = String(json.Referencedescription);
                        } else {
                            $w('#description').text = 'לא סופק תיאור.';
                        }

                        if (json.modelname) {
                            $w('#productType').text = String(json.modelname);
                        } else {
                            $w('#productType').text = 'שגיאת סוג מוצר.';
                        }

                        if (json.Customernotice) {
                            $w('#customerNotice').text = String(json.Customernotice);
                        } else {
                            $w('#customerNotice').text = 'לא נמסרה הודעה.';
                        }

                        if (json.closedate) {
                            $w('#closedOn').text = String(json.closedate);
                        } else {
                            $w('#closedOn').text = 'הבקשה עדיין בתהליך.';
                        }

                        if (json.Shipingcompany) {
                            $w('#shippingCompany').text = String(json.Shipingcompany);

                            if (json.phoneshippingcompany) {
                                $w('#shippingPhone').text = String(json.phoneshippingcompany);
                            } else {
                                $w('#shippingPhone').text = '-';
                            }

                            if (json.Shippingnote) {
                                $w('#shippingNote').text = String(json.Shippingnote);
                            } else {
                                $w('#shippingNote').text = '-';
                            }
                        } else {
                            $w('#shippingCompany').text = '-';
                            $w('#shippingPhone').text = '-';
                            $w('#shippingNote').text = '-';
                        }

                        $w('#requestStages').changeState('success');
                    } else {
                        if (result.json.reason === 'not found') {
                            $w('#checkingRequestErrorMsg').text = 'הפניה לאחריות שהוזנה אינה קיימת.';
                            $w('#checkingRequestErrorMsg').expand();
                            $w('#requestStages').changeState('step1');
                        } else {
                            $w('#universalError').text = `אירעה שגיאה - הודעת שגיאה: ${result.json.message}.`;
                            $w('#universalError').expand();
                            $w('#requestStages').changeState('error');
                        }
                    }

                }).catch(async (err) => {
                    console.error(err.adminMessage);
                    $w('#checkingRequestErrorMsg').text = err.message || "Unable to send request at the moment";
                    $w('#checkingRequestErrorMsg').expand();
                    $w('#requestStages').changeState('step1');
                })
            })
        })

        $w('#startAgain').onClick(() => {
            $w('#fullName, #warrantyReference').value = '';
            $w('#checkRequest').disable();
            $w('#requestStages').changeState('step1');
        })
    }

}
/*	==================================================================================================================================
	==================================================================================================================================
	===================================== Copyright: Nasriya Software, LLC. (www.nasriya.net) ========================================
	==================================================================================================================================
	==================================================================================================================================
*/